import React, { FC, ReactNode }   from 'react';
import { DashPage }               from './DashContainerPage';
import { Dropdown, Button, Icon } from 'semantic-ui-react';

type MenuHash = Array<MenuHashItem>;

interface MenuHashItem {
    header: string;
    items: Array<{ onClick: () => void; content: ReactNode }>;
}

interface DashOperationsDialogProps {
    editMode: boolean;
    onToggleEdit: () => void;
    onNewPage: () => void;
    onDeletePage: () => void;
    dashPages: DashPage[];
    onDashPageChange: (id: string ) => void;
}

const DashOperationsDialog: FC<DashOperationsDialogProps> = ({
    editMode,
    onToggleEdit,
    onNewPage,
    onDeletePage,
    dashPages,
    onDashPageChange,
}) => {


    const operationsHash: MenuHash = [
        {
            header: 'Reports',
            items: dashPages.map(page => ({
                onClick: () => onDashPageChange(page.id),
                content: <><Icon name={page.icon || "file text"} color="purple" /> {page.name}</>
            }))
        },
        {
            header: 'Page Operations',
            items: [
                {
                    onClick: onNewPage,
                    content: <><Icon name="plus" color="purple" /> New Page</>
                },
                {
                    onClick: onDeletePage,
                    content: <><Icon name="trash" color="purple" /> Delete Page</>
                }
            ]
        }
    ];

    const editHash: MenuHash = [
        {
            header: 'Edit',
            items: [
                {
                    onClick: onToggleEdit,
                    content: <><Icon name={editMode ? 'eye' : 'edit'} color="purple" /> {editMode ? 'View Mode' : 'Edit Mode'}</>
                }
            ]
        }
    ];

    const renderDropdown = (menuHash: MenuHash, triggerIcon: string) => (
        <Dropdown
            icon={null}
            direction="left"
            closeOnEscape={true}
            closeOnBlur={true}
            trigger={
                <Button icon basic>
                    <Icon name={triggerIcon} />
                </Button>
            }
        >
            <Dropdown.Menu>
                {menuHash.map((menuGroup) => (
                    <React.Fragment key={`menu-group-${menuGroup.header}`}>
                        <Dropdown.Header>{menuGroup.header}</Dropdown.Header>
                        {menuGroup.items.map((item, index) => (
                            <Dropdown.Item
                                key={`menu-item-${menuGroup.header}-${index}`}
                                onClick={item.onClick}
                                content={item.content}
                            />
                        ))}
                    </React.Fragment>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );

    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            {renderDropdown(operationsHash, 'ellipsis vertical')}
            {renderDropdown(editHash, editMode ? 'eye' : 'edit')}
        </div>
    );
};

export default DashOperationsDialog;
